import { Injectable, inject } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { SysUtilService } from './sysUtil.service';
import { env } from '../../../app.constant';
import { SabaudbPREService } from './BudgetReports/sabaudb-pre.service';
import { SabaudbSbService } from './BudgetReports/sabaudb-sb.service';
import { SabaudbSbSumService } from './BudgetReports/sabaudb-sb-sum.service';
import { SabaudbStfService } from './BudgetReports/sabaudb-stf.service';
import { SabaudbStfSumService } from './BudgetReports/sabaudb-stf-sum.service';


@Injectable()
export class SABAUDBReportUtilService {

    private sysUtil: SysUtilService = inject(SysUtilService);
    private sabaudbPRE: SabaudbPREService = inject(SabaudbPREService);
    private sabaudbSB: SabaudbSbService = inject(SabaudbSbService);
    private sabaudbSBSUM: SabaudbSbSumService = inject(SabaudbSbSumService);
    private sabaudbSTF: SabaudbStfService = inject(SabaudbStfService);
    private sabaudbSTFSUM: SabaudbStfSumService = inject(SabaudbStfSumService);

    private sheetTitles: any = {
        pre_function: "PRE",
        pre_ooe: "PRE - OOE",
        pre_ac: "PRE - AC",
        sb_function: "SB",
        sb_ooe: "SB - OOE",
        sb_ac: "SB - AC",
        sb_functionsum: "SB SUM",
        sb_ooesum: "SB SUM - OOE",
        sb_acsum: "SB SUM - AC",
        stf_function: "STF",
        stf_ooe: "STF - OOE",
        stf_ac: "STF - AC",
        stf_functionsum: "STF SUM",
        stf_ooesum: "STF SUM - OOE",
        stf_acsum: "STF SUM - AC",
    };

    async generateExcel(content: Array<any>, campus: number, year: number, options: any = { fileName: "SABAUDB", sheetName: [] }) {

        let data = { pre: {}, sb: {}, stf: {} };
        let keys = Object.keys(this.sheetTitles);

        Object.keys(this.sheetTitles).forEach((key: string) => {
            let fs = key.split('_')[0];
            let type = key.split('_')[1];
            content[fs][type].forEach((dat: any) => {
                // dat.fnd_name = dat.fnd_name.replaceAll(/(<([^>]+)>)|(\&nbsp;)/ig, '');
                dat.fnd_name = dat.fnd_name.replaceAll(/<([^>]+)>/ig, '');
                dat.fnd_name = dat.fnd_name.replaceAll(/&nbsp;/g, ' ');
            });
            data[fs][type] = content[fs][type];
        });

        // content.forEach((dat: any) => {
        //     dat.forEach((d: any) => {
        //         // let dt = JSON.parse(JSON.stringify(d));
        //         d.fnd_name = d.fnd_name.replaceAll(/(<([^>]+)>)|(\&nbsp;)/ig, '');
        //     });
        //     data.push(dat);
        // });

        const wb = new ExcelJS.Workbook();

        const imagePath = './assets/BatStateULogo.png';
        this.sysUtil.getBase64ImageFromUrl(imagePath).then(async (result: any) => {

            // let i = 0;
            keys.forEach((sn: string) => {
                let k = sn.split('_')[0];
                let t = sn.split('_')[1];
                if (k === "pre") {
                    this.sabaudbPRE.createWorkSheet(wb, data[k][t], campus, year, this.sheetTitles[sn], result);
                    // i++;
                }
                if (k === "sb") {
                    if (["function", "ooe", "ac"].includes(t)) {
                        this.sabaudbSB.createWorkSheet(wb, data[k][t], campus, year, this.sheetTitles[sn], result);
                    }
                    if (["functionsum", "ooesum", "acsum"].includes(t)) {
                        this.sabaudbSBSUM.createWorkSheet(wb, data[k][t], campus, year, this.sheetTitles[sn], result);
                    }
                }
                if (k === "stf") {
                    if (["function", "ooe", "ac"].includes(t)) {
                        this.sabaudbSTF.createWorkSheet(wb, data[k][t], campus, year, this.sheetTitles[sn], result);
                    }
                    if (["functionsum", "ooesum", "acsum"].includes(t)) {
                        this.sabaudbSTFSUM.createWorkSheet(wb, data[k][t], campus, year, this.sheetTitles[sn], result);
                    }

                }

            });

            const arrayData = await wb.xlsx.writeBuffer();
            const blob = new Blob([arrayData], { type: "application/octet-binary" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${options.fileName}.xlsx`;
            a.click();
            a.remove();

        });
    }

}
